import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LMModel } from '@form/model';

@Component({
  selector:    'lm-radiobutton',
  standalone: false,
  templateUrl: './lm-radiobutton.component.html',
  styleUrls:   [ 'lm-radiobutton.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMRadiobuttonComponent {
  @Input() layoutObject: LMRadioButtonLayout | undefined;
  @Input() layoutInfo: LMFormLayoutInfo | undefined;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo | undefined;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo | undefined;
  @Input() parentCompoundFieldDisplayOnly = false;
  @Input() specFields: LMSpecFields | undefined;
  @Input() model: LMModel | undefined;
  @Input() placeHolder: any;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  onFieldEvent($event: LMFieldEvent) {
    this.fieldEvent.emit($event);
  }
}
